var getDarkModeSystemPreference = () => {
  if (typeof window === 'undefined') return false;
  if (!window.matchMedia) return false;
  return window.matchMedia('(prefers-color-scheme: dark)').matches;
};

export { getDarkModeSystemPreference as g };
//# sourceMappingURL=getDarkModeSystemPreference-COXcx2eW.js.map
